import { useUserOrganizationRole } from '@/hooks/useUserRole';
import { createLogger } from '@/lib/logger';
import { Navigate } from 'react-router-dom';

const log = createLogger('ViewerRestrictedRoute');

/**
 * Route component that restricts access for VIEWER role
 * Redirects to 404 if user is a VIEWER
 */
export function ViewerRestrictedRoute({
  children,
}: {
  children: React.ReactNode;
}) {
  const userOrganizationRole = useUserOrganizationRole();

  // VIEWER role cannot access this route
  if (userOrganizationRole === 'VIEWER') {
    log.warn('Viewer role attempted to access restricted route');
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}

